module.exports = __webpack_public_path__ + "static/media/local-central-mobile@2x.36f84c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-central-mobile@2x.png
// module id = 1181
// module chunks = 2